module.exports = __webpack_public_path__ + "media/images/powerpoint/csa-background-a46915ae8ef8c55b0e430e5ebdc6a3ac.png";